/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import OrdersTable from './OrdersTable';
import OthersOrdersTable from './OthersOrdersTable';
import {useSelector} from 'react-redux';
import {SELECTOR_USER} from '../../redux/selectors/auth';

export default function OrdersList() {
  const session = useSelector(SELECTOR_USER);

  return (
    <Box mb={2}>
      <Box mb={2}>
        <Typography>Pedidos en la web</Typography>
      </Box>
      <OrdersTable />
      {session.owner_company === 'true' && (
        <React.Fragment>
          <Box mb={2}>
            <Typography>Otros pedidos</Typography>
          </Box>
          <OthersOrdersTable />
        </React.Fragment>
      )}
    </Box>
  );
}
